module.exports = __webpack_public_path__ + "static/gun_emoji-f52b5e2c37a4a1acd2574a6d86acf606.svg";